import { Cell, Grid, HeadingSection, HFlow, VFlow } from 'bold-ui'
import { FormRenderProps, RadioField } from 'components/form'
import { AgeRangeField } from 'components/form/field/AgeRangeField'
import { css } from 'emotion'
import { AgeRangeType, FaixaEtariaEnum } from 'graphql/types.generated'
import { MetaRoot } from 'util/metaPath'

import { TipoVulnerabilidadeEnum } from '../acompanhamento-condicao-saude/model/model-acompanhamentoCondicaoSaude'
import { AcompanhamentoFilterModel, faixaEtariaRecord } from '../model/model-acompanhamentoFilter'

interface FaixaEtariaFilterGroupProps<T> {
  change: FormRenderProps<AcompanhamentoFilterModel>['form']['change']
  meta: MetaRoot<T>
  faixaEtariaFilter: FormRenderProps<AcompanhamentoFilterModel>['values']['tipoFaixaEtaria']
  tipoVulnerabilidade?: TipoVulnerabilidadeEnum
  isInsideModal?: boolean
}

export function FaixaEtariaFilterGroup<T extends AcompanhamentoFilterModel>(props: FaixaEtariaFilterGroupProps<T>) {
  const { faixaEtariaFilter, change, meta, tipoVulnerabilidade, isInsideModal = false } = props

  const isBotaoIvcfHabilitado = tipoVulnerabilidade === TipoVulnerabilidadeEnum.IVCF

  const handleAgeRangeChange = () => change(meta.faixaEtariaRange.absolutePath(), undefined)

  return (
    <Grid>
      <Cell size={12} style={styles.titleFaixaEtaria}>
        {!isInsideModal && <HeadingSection title='Faixa etária' level={5} />}
      </Cell>
      <Cell size={4} style={styles.columnFaixaEtaria}>
        <VFlow vSpacing={0.5}>
          <RadioField
            name={meta.tipoFaixaEtaria}
            value={FaixaEtariaEnum.TODAS_FAIXAS}
            label={faixaEtariaRecord[FaixaEtariaEnum.TODAS_FAIXAS]}
            onChange={handleAgeRangeChange}
            disabled={isBotaoIvcfHabilitado}
          />
          <RadioField
            name={meta.tipoFaixaEtaria}
            value={FaixaEtariaEnum.CRIANCA}
            label={faixaEtariaRecord[FaixaEtariaEnum.CRIANCA]}
            onChange={handleAgeRangeChange}
            disabled={isBotaoIvcfHabilitado}
          />
          <RadioField
            name={meta.tipoFaixaEtaria}
            value={FaixaEtariaEnum.ADOLESCENTE}
            label={faixaEtariaRecord[FaixaEtariaEnum.ADOLESCENTE]}
            onChange={handleAgeRangeChange}
            disabled={isBotaoIvcfHabilitado}
          />
        </VFlow>
      </Cell>
      <Cell size={8} style={styles.columnFaixaEtaria}>
        <VFlow vSpacing={0.5}>
          <RadioField
            name={meta.tipoFaixaEtaria}
            value={FaixaEtariaEnum.ADULTO}
            label={faixaEtariaRecord[FaixaEtariaEnum.ADULTO]}
            onChange={handleAgeRangeChange}
            disabled={isBotaoIvcfHabilitado}
          />
          <RadioField
            name={meta.tipoFaixaEtaria}
            value={FaixaEtariaEnum.IDOSO}
            label={faixaEtariaRecord[FaixaEtariaEnum.IDOSO]}
            onChange={handleAgeRangeChange}
          />
          <HFlow style={styles.rowOutra}>
            <RadioField
              name={meta.tipoFaixaEtaria}
              value={FaixaEtariaEnum.OUTRA}
              label={faixaEtariaRecord[FaixaEtariaEnum.OUTRA]}
              onChange={handleAgeRangeChange}
            />
            <AgeRangeField
              name={meta.faixaEtariaRange}
              disabled={faixaEtariaFilter !== FaixaEtariaEnum.OUTRA}
              rangeTypeOptions={
                isBotaoIvcfHabilitado ? [AgeRangeType.ANOS] : [AgeRangeType.ANOS, AgeRangeType.MESES, AgeRangeType.DIAS]
              }
              firstInputPlaceholder={isBotaoIvcfHabilitado ? 'Idade mínima (60)' : 'Idade mínima'}
            />
          </HFlow>
        </VFlow>
      </Cell>
    </Grid>
  )
}

const styles = {
  titleFaixaEtaria: css`
    padding-bottom: 0;
  `,
  columnFaixaEtaria: css`
    padding-top: 0;
  `,
  rowOutra: css`
    max-width: 28rem;
  `,
}
